import { Dayjs } from 'dayjs';

import { LOCALES } from 'src/interfaces/i18n.types';

const monthFormat =
  'Січня_Лютого_Березня_Квітня_Травня_Червня_Липня_Серпня_Вересня_Жовтня_Листопада_Грудня'.split(
    '_',
  );
const monthStandalone =
  'Січень_Лютий_Березень_Квітень_Травень_Червень_Липень_Серпень_Вересень_Жовтень_Листопад_Грудень'.split(
    '_',
  );

const MONTHS_IN_FORMAT = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;

const months = (dayjsInstance: Dayjs, format: string) => {
  if (MONTHS_IN_FORMAT.test(format)) {
    return monthFormat[dayjsInstance.month()];
  }
  return monthStandalone[dayjsInstance.month()];
};
months.s = monthStandalone;
months.f = monthFormat;

const ukLocale: Partial<ILocale> = {
  name: LOCALES.UA,
  weekdays: 'Неділя_Понеділок_Вівторок_Середа_Четвер_Пʼятниця_Субота'.split(
    '_',
  ),
  weekdaysShort: 'Ндл_Пнд_Втр_Срд_Чтв_Птн_Сбт'.split('_'),
  weekdaysMin: 'Нд_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
  //  @ts-expect-error months also can be a function
  months,
  monthsShort: 'Січ_Лют_Бер_Квіт_Трав_Черв_Лип_Серп_Вер_Жовт_Лист_Груд'.split(
    '_',
  ),
};

export { ukLocale };
